export const ATSCompany = (data) => {
    return {
        id: data?.id || null,
        name: data?.name || "",
        domain: data?.domain || "",
    };
}